import { List, ListItem } from '@/comps/list';
import { cn } from '@/utils/shad';
import { ChevronRightIcon } from 'lucide-react';
import { FILTER_OPERATORS, FilterOperator, getOperatorLabel } from '@/comps/FilterPicker/filter-operators';

type Props = {
  selectedOperator?: FilterOperator | null;
  onSelectOperator: (operator: FilterOperator) => void;
  className?: string;
};

export function FilterOperatorStep({ selectedOperator, onSelectOperator, className }: Props) {
  return (
    <List className={cn('z-50 flex flex-col', className)}>
      {FILTER_OPERATORS.map((operator) => (
        <ListItem
          key={operator}
          data-tour={operator === 'contains' ? 'filter-v2-operator-contains' : undefined}
          className={cn(
            'flex cursor-pointer items-center justify-between rounded-[8px] px-3 py-2 transition-colors hover:bg-neutral-800',
            selectedOperator === operator && 'bg-neutral-800',
          )}
          onClick={() => onSelectOperator(operator)}
        >
          <span className="text-xs text-foreground">{getOperatorLabel(operator)}</span>
          <ChevronRightIcon className="text-muted-foreground" size={16} />
        </ListItem>
      ))}
    </List>
  );
}
